




import { defineComponent } from '@nuxtjs/composition-api';

interface Props extends Blok {
  name: string;
  description?: string;
  scriptContent: string;
  htmlContent: string;
}

export default defineComponent({
  props: {
    blok: {
      type: Object as () => Props,
      required: true,
    },
  },
  mounted() {
    const { scriptContent } = this.blok;
    if (scriptContent) {
      // eslint-disable-next-line no-eval
      eval(scriptContent);
    }
  },
});
